import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ipbx-app',
    template: `<router-outlet></router-outlet>`
})
export class IPBXComponent implements OnInit {
    constructor() { }

    ngOnInit() { }
}
